import React from 'react'
// import "../css/post-3563.css"
const Contactus = () => {
    return (
        <div
            data-elementor-type="wp-page"
            data-elementor-id="18"
            className="elementor elementor-3563"
        >
            <div
                className="elementor-element elementor-element-8b51153 e-con-full e-flex e-con e-parent e-lazyloaded"
                data-id="8b51153"
                data-element_type="container"
                data-settings='{"background_background":"classic"}'
                style={{"--min-height":"433px"}}
            >
                <div
                    className="elementor-element elementor-element-f334b2e e-con-full qodef-elementor-content-grid e-flex e-con e-child"
                    data-id="f334b2e"
                    style={{"--padding-top":"71px"}}
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-36aee5c elementor-widget__width-initial elementor-widget elementor-widget-startpro_core_section_title"
                        data-id="36aee5c"
                        data-element_type="widget"
                        data-widget_type="startpro_core_section_title.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--center ">
                                <h1 className="qodef-m-title">We want to hear you! </h1>
                                {/* <span className="qodef-m-description" style={{ marginTop: 12 }}>
                                    Lorem ipsum dolor sit amet, dicunt electram ut has, possim blandit
                                    urbanitas at sea. Nemore essent tractatos dolorem.{" "}
                                </span> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="elementor-element elementor-element-e499ad2 e-con-full qodef-elementor-content-grid e-flex e-con e-parent e-lazyloaded"
                data-id="e499ad2"
                data-element_type="container"
            >
                <div
                    className="elementor-element elementor-element-8f291d2 elementor-widget elementor-widget-startpro_core_single_image"
                    data-id="8f291d2"
                    data-element_type="widget"
                    data-widget_type="startpro_core_single_image.default"
                >
                    <div className="elementor-widget-container">
                        <div className="qodef-shortcode qodef-m  qodef-single-image qodef-layout--default  qodef-border-radius--yes qodef-how-border--no    " style={{ "--qode-single-image-border-radius-size": "20px" }}>
                            <div className="qodef-m-image">
                                <img
                                    fetchpriority="high"
                                    decoding="async"
                                    width={1300}
                                    height={556}
                                    src="/img/contact-hd-bg.jpg"
                                    className="qodef-image-original"
                                    alt="f"
                                   
                                    sizes="(max-width: 1300px) 100vw, 1300px"
                                />{" "}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='elementor-element elementor-element-b503e26 e-con-full qodef-elementor-content-grid e-flex e-con e-parent e-lazyloaded' data-element_type="container">
                <div
                    className="elementor-element elementor-element-7bc5cc9 e-con-full e-flex e-con e-child"
                    data-id="7bc5cc9"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-ad6f80c e-con-full e-flex e-con e-child"
                        data-id="ad6f80c"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-4919793 elementor-widget__width-initial elementor-widget elementor-widget-startpro_core_section_title"
                            data-id={4919793}
                            data-element_type="widget"
                            data-widget_type="startpro_core_section_title.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                                    <h2 className="qodef-m-title">Let’s connect! </h2>
                                    <span className="qodef-m-description" style={{ marginTop: 5 }}>
                                        Have a question about us or a need help with your work? We are here
                                        to help.{" "}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-103707e e-con-full e-flex e-con e-child"
                        data-id="103707e"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-888a71a elementor-widget__width-initial elementor-widget elementor-widget-wp-widget-startpro_core_contact_form_7"
                            data-id="888a71a"
                            data-element_type="widget"
                            data-widget_type="wp-widget-startpro_core_contact_form_7.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-contact-form-7 ">
                                    <div
                                        className="wpcf7 js"
                                        id="wpcf7-f2421-p3563-o1"
                                        lang="en-US"
                                        dir="ltr"
                                        data-wpcf7-id={2421}
                                    >
                                        <div className="screen-reader-response">
                                            <p role="status" aria-live="polite" aria-atomic="true" /> <ul />
                                        </div>
                                        <form
                                            action="/contact-us/#wpcf7-f2421-p3563-o1"
                                            method="post"
                                            className="wpcf7-form init demo"
                                            aria-label="Contact form"
                                            noValidate="novalidate"
                                            data-status="init"
                                        >
                                            <div style={{ display: "none" }}>
                                                <input type="hidden" name="_wpcf7" defaultValue={2421} />
                                                <input
                                                    type="hidden"
                                                    name="_wpcf7_version"
                                                    defaultValue="6.0.3"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="_wpcf7_locale"
                                                    defaultValue="en_US"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="_wpcf7_unit_tag"
                                                    defaultValue="wpcf7-f2421-p3563-o1"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="_wpcf7_container_post"
                                                    defaultValue={3563}
                                                />
                                                <input
                                                    type="hidden"
                                                    name="_wpcf7_posted_data_hash"
                                                    defaultValue=""
                                                />
                                            </div>
                                            <span className="wpcf7-form-control-wrap" data-name="your-name">
                                                <input
                                                    size={40}
                                                    maxLength={400}
                                                    className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                    autoComplete="name"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    placeholder="Name"
                                                    defaultValue=""
                                                    type="text"
                                                    name="your-name"
                                                />
                                            </span>
                                            <span className="wpcf7-form-control-wrap" data-name="your-email">
                                                <input
                                                    size={40}
                                                    maxLength={400}
                                                    className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email"
                                                    autoComplete="email"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    placeholder="E-mail address"
                                                    defaultValue=""
                                                    type="email"
                                                    name="your-email"
                                                />
                                            </span>
                                            <span
                                                className="wpcf7-form-control-wrap"
                                                data-name="your-message"
                                            >
                                                <textarea
                                                    cols={40}
                                                    rows={10}
                                                    maxLength={2000}
                                                    className="wpcf7-form-control wpcf7-textarea"
                                                    aria-invalid="false"
                                                    placeholder="Message"
                                                    name="your-message"
                                                    defaultValue={""}
                                                />
                                            </span>
                                            <button
                                                className="wpcf7-form-control wpcf7-submit qodef-button qodef-size--normal qodef-layout--filled qodef-m"
                                                type="submit"
                                            >
                                                <span className="qodef-m-text">Send message</span>
                                            </button>
                                            <div className="wpcf7-response-output" aria-hidden="true" />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-element elementor-element-98b6960 e-con-full e-flex e-con e-child" data-id="98b6960" data-element_type="container" data-settings='{"background_background":"classic"}'>
                    <div className="elementor-element elementor-element-dcaabed elementor-widget elementor-widget-startpro_core_google_map" data-id="dcaabed" data-element_type="widget" data-widget_type="startpro_core_google_map.default">
                        <div className="elementor-widget-container">
                            <div className="qodef-shortcode qodef-m qodef-google-map">
                                <div
                                    className="qodef-m-map"
                                    id="qodef-map-id--348"

                                    data-unique-id="348"
                                    data-height="500"
                                    style={{ height: '500px', position: 'relative', overflow: 'hidden' }}
                                >
                                    <div style={{ height: '100%', width: '100%', position: 'absolute', top: '0px', left: '0px', backgroundColor: 'rgb(229, 227, 223)' }}>
                                    {/* <iframe
                    width="100%"
                    style={{ height: "100vh" }}
                    id="gmap_canvas"
                    src="https://maps.google.com/maps?q=House%20%2317%20K3,%20WAPDA%20Town%20Phase%201%20Lahore,%20Punjab%2054000,%20Pakistan&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  ></iframe> */}
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8673.640363526829!2d58.44835100000001!3d23.601896!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ff39823b555b%3A0x8ecbe6acff6cbd21!2sPMC%20Head%20Office!5e1!3m2!1sen!2sin!4v1741754393174!5m2!1sen!2sin" width="600" height="450" style={{border:"0px",height: "100%"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contactus
